import { useReducedMotion } from "motion/react";
import { useState } from "react";

const LEAVE_DURATION_MS = 450;

export function useLeavingItems() {
  const prefersReducedMotion = useReducedMotion();
  const [leaving, setLeaving] = useState<ReadonlySet<number>>(new Set());

  const leave = (ids: number[], commit: () => void) => {
    if (prefersReducedMotion) {
      commit();
      return;
    }
    setLeaving((previous) => new Set([...previous, ...ids]));
    window.setTimeout(() => {
      commit();
      setLeaving(
        (previous) => new Set([...previous].filter((id) => !ids.includes(id))),
      );
    }, LEAVE_DURATION_MS);
  };

  return { isLeaving: (id: number) => leaving.has(id), leave };
}
